import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "columns" }
const _hoisted_2 = { class: "column is-7" }
const _hoisted_3 = { class: "column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CronometroVue = _resolveComponent("CronometroVue")!
  const _component_BoxVue = _resolveComponent("BoxVue")!

  return (_openBlock(), _createBlock(_component_BoxVue, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.tarefa.descricao || `Tarefa ${_ctx.id + 1}`), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_CronometroVue, {
            "tempo-segundos": _ctx.tarefa.duracaoEmSegundos
          }, null, 8, ["tempo-segundos"])
        ])
      ])
    ]),
    _: 1
  }))
}